export default function themePrefix(themeId, key) {
  return `theme_translations.${themeId}.${key}`;
}
